<!-- Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. -->
<dialog-titlebar [title]="data.title" [showIconButton]="false"></dialog-titlebar>
<mat-dialog-content>
	<div class="allowed-list-modal-content">
		<p>{{ data.content }}</p>
		<mat-form-field subscriptSizing="dynamic">
			<mat-label>Allow list</mat-label>
			<textarea
				matInput
				class="remove-old-textarea-styling"
				[formControl]="linksString"
				cdkTextareaAutosize
				#autosize="cdkTextareaAutosize"
				cdkAutosizeMinRows="25"
			></textarea>
		</mat-form-field>
	</div>
</mat-dialog-content>
<button-footer
	mat-dialog-actions
	(buttonSaveOrClose)="onButtonSaveSelect()"
	[saveOrCloseButtonText]="data.yesButtonText"
>
	<button leftButton mat-button color="primary" mat-dialog-close automationId="noButton">
		{{ data.noButtonText }}
	</button>
</button-footer>
